import * as React from "react";
import { BrowserRouter } from "react-router-dom";

import ProtectedRoutes from "./protected/ProtectedRoutes";
import PublicRoutes from "./public/PublicRoutes";
import { useCurrentUserQuery } from "data/user/user";
import { useSiteStatusQuery } from "data/app/app";

const Router: React.FC = () => {
  const { data: user, isLoading: userLoading } = useCurrentUserQuery();
  const { isLoading: siteStatusLoading } = useSiteStatusQuery();

  if (userLoading || siteStatusLoading) {
    return null;
  }

  return (
    <BrowserRouter>
      {user != null ? <ProtectedRoutes /> : <PublicRoutes />}
    </BrowserRouter>
  );
};
export default Router;
